import React, { useState, useEffect, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import { Button } from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { toast } from "react-toastify";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const FinanceHeadPayoutAccept = ({
  payoutDetailsWithId,
  match,
  getAllThePayoutDetailsWithId = [],
  documentUrlDataPublic,
  documentUploadUrlPublic,
  updateAllPayoutDetails,
}) => {
  const [inputList, setInputList] = useState({
    modification_payout_amount: "",
    modification_payout_percentage: "",
    upload_approval_document: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [modificationRow, setModificationRow] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      await payoutDetailsWithId(match?.params?.id);
    })();
    setIsLoading(false);
  }, [match?.params?.id, payoutDetailsWithId]);

  const handleModify = () => {
    setModificationRow(true);
  };

  const handleModalHide = () => setIsModal(false);

  const handleAccept = async () => {
    const inputData = [
      {
        ...inputList,
        action: "accept",
        loan_application_id: parseInt(match?.params?.id),
        modification_payout_amount:
          getAllThePayoutDetailsWithId?.final_payout_amount,
        modification_payout_percentage:
          getAllThePayoutDetailsWithId?.final_payout_percentage,
      },
    ];

    // console.log("INPUT LISTING: ", inputData)
    // return false

    setIsLoading(true);
    const res = await updateAllPayoutDetails(inputData);
    if (res.status === true) {
      setIsModal(true);
    }
    setIsLoading(false);
  };

  return (
    <Layout title={"Payout Requests"} isGoback isLoading={isLoading}>
      {getAllThePayoutDetailsWithId?.track?.length > 0 ? (
        <Fragment>
          <div className="panel-card">
            <div className="panel-heading">Payout Request(Finance Head)</div>
            <div className="panel-body">
              <div className="details-listing mb-5">
                <table className="table table-bordered mr-4">
                  <tbody>
                    {(() => {
                      const defaultGeneratedItem =
                        getAllThePayoutDetailsWithId?.track.find(
                          (trackItem) =>
                            trackItem?.status == "DEFAULT_GENERATED"
                        );
                      const modifiedByDSMItem =
                        getAllThePayoutDetailsWithId?.track.find(
                          (trackItem) => trackItem.status == "MODIFIED_BY_DSM"
                        );
                      const modifiedByCentralOpsItem =
                        getAllThePayoutDetailsWithId?.track.find(
                          (trackItem) =>
                            trackItem?.status == "MODIFIED_BY_CENTRAL_OPS"
                        );
                      const modifiedByBussinessHeadItem =
                        getAllThePayoutDetailsWithId?.track.find(
                          (trackItem) =>
                            trackItem?.status == "MODIFIED_BY_BUSINESS_HEAD"
                        );

                      if (
                        !modifiedByDSMItem &&
                        !modifiedByCentralOpsItem &&
                        !modifiedByBussinessHeadItem
                      ) {
                        return (
                          <>
                            <tr>
                              <th>Default Payout Amount</th>
                              <td>
                                {"Rs. " +
                                  getAllThePayoutDetailsWithId?.final_payout_amount}
                              </td>
                            </tr>
                            <tr>
                              <th>Default Payout Percentage</th>
                              <td>
                                {getAllThePayoutDetailsWithId?.final_payout_percentage +
                                  "%"}
                              </td>
                            </tr>
                            <tr>
                              <th>Status</th>
                              <td>{getAllThePayoutDetailsWithId?.status}</td>
                            </tr>
                          </>
                        );
                      }

                      if ( modifiedByDSMItem || modifiedByCentralOpsItem ||
                          modifiedByBussinessHeadItem
                      ) {
                        return (
                          <>
                            <tr>
                              <th>Default Payout Amount</th>
                              <td>
                                {"Rs. " + defaultGeneratedItem?.payout_amount}
                              </td>
                            </tr>
                            <tr>
                              <th>Default Payout Percentage</th>
                              <td>
                                {defaultGeneratedItem?.payout_percentage + "%"}
                              </td>
                            </tr>
                            <tr>
                              <th>Status</th>
                              <td>{getAllThePayoutDetailsWithId?.status}</td>
                            </tr>

                            {modifiedByDSMItem && (
                              <>
                                <tr>
                                  <th>Payout Amount suggested by DSM</th>
                                  <td>
                                    {"Rs. " + modifiedByDSMItem?.payout_amount}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Payout Percentage suggested by DSM</th>
                                  <td>
                                    {modifiedByDSMItem?.payout_percentage + "%"}
                                  </td>
                                </tr>
                                <tr>
                                  <th>DSM File</th>
                                  <td>
                                    <a
                                      href={
                                        modifiedByDSMItem?.payout_modification_proof_url
                                      }
                                      className="btn btn-primary btn-sm"
                                      target={"_blank"}
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa fa-download"></i>{" "}
                                      Download
                                    </a>
                                  </td>
                                </tr>
                              </>
                            )}

                            {modifiedByCentralOpsItem && (
                              <>
                                <tr>
                                  <th>
                                    Payout Amount suggested by Central Ops
                                  </th>
                                  <td>
                                    {"Rs. " +
                                      modifiedByCentralOpsItem?.payout_amount}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Payout Percentage suggested by Central Ops
                                  </th>
                                  <td>
                                    {modifiedByCentralOpsItem?.payout_percentage +
                                      "%"}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Central Ops File</th>
                                  <td>
                                    <a
                                      href={
                                        modifiedByCentralOpsItem?.payout_modification_proof_url
                                      }
                                      className="btn btn-primary btn-sm"
                                      target={"_blank"}
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa fa-download"></i>{" "}
                                      Download
                                    </a>
                                  </td>
                                </tr>
                              </>
                            )}
                            {modifiedByBussinessHeadItem && (
                              <>
                                <tr>
                                  <th>
                                    Payout Amount suggested by Business Head
                                  </th>
                                  <td>
                                    {"Rs. " +
                                      modifiedByBussinessHeadItem?.payout_amount}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Payout Percentage suggested by Business Head
                                  </th>
                                  <td>
                                    {modifiedByBussinessHeadItem?.payout_percentage +
                                      "%"}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Business Head File</th>
                                  <td>
                                    <a
                                      href={
                                        modifiedByBussinessHeadItem?.payout_modification_proof_url
                                      }
                                      className="btn btn-primary btn-sm"
                                      target={"_blank"}
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa fa-download"></i>{" "}
                                      Download
                                    </a>
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        );
                      }
                      return null;
                    })()}
                  </tbody>
                </table>
                <>
                  {!modificationRow &&
                    (getAllThePayoutDetailsWithId.status ==
                      "Modified By Business Head" ||
                      getAllThePayoutDetailsWithId.status ==
                        "Accepted By Business Head") && (
                      <div className="d-flex mb-3 mb-3">
                        <Button
                          className="btn btn-sm btn-success mr-3"
                          onClick={handleAccept}
                        >
                          Accept
                        </Button>
                      </div>
                    )}
                </>
              </div>
            </div>
          </div>

          <ModalPop
            title={localization.conf}
            show={isModal}
            handleModalHide={handleModalHide}
            keyboard
            backdrop
          >
            <div className="text-center">
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>Updated Successfully</h5>
              <Link
                to={`${baseUrl}/ucd/finance-head-payout-release-list`}
                className="btn btn-primary mb-4"
              >
                Go to UCD List <img src={Images?.ArrowRight} alt="" />
              </Link>
            </div>
          </ModalPop>
        </Fragment>
      ) : (
        <Fragment>
          <div>
            <img src={Images?.NoData} alt="No data" width="100%" />
          </div>
        </Fragment>
      )}
    </Layout>
  );
};

export default FinanceHeadPayoutAccept;
